function t(t){return t?"string"==typeof t?parseFloat(t):t:0}export{t as toNumber};
//# sourceMappingURL=toNumber.js.map
